import {isLoggedIn} from '@github-ui/client-env'
import {useUser} from '@github-ui/use-user'
import {useMemo} from 'react'

import type {SavedView} from '../../types'
import {splitViewsByVisibility} from '../../utils/views-visibility'
import type {PinControls} from './PinViewMenuItem'
import styles from './RepositoryViews.module.css'
import {ViewsSection} from './ViewsSection'

type ViewsSectionsProps = {
  views: SavedView[]
  owner: string
  repo: string
  newViewUrl: string
  viewerCanManageViews?: boolean
  showPinControls?: boolean
  pinControls?: PinControls
}

export function ViewsSections({
  views,
  owner,
  repo,
  newViewUrl,
  viewerCanManageViews = false,
  showPinControls = false,
  pinControls,
}: ViewsSectionsProps) {
  const {team, personal} = useMemo(() => splitViewsByVisibility(views), [views])
  const {currentUser} = useUser()
  // Data Router routes such as account level Planning ship neither an app payload nor a
  // UserContext, so the viewer is unknown here. The client env is on every page, signed in
  // or not, and answers the only question this needs to ask.
  const hasPersonalSection = currentUser != null || isLoggedIn()

  const shared = {owner, repo, newViewUrl, viewerCanManageViews, showPinControls, pinControls}

  return (
    <div className={styles.viewsSections}>
      {hasPersonalSection && (
        <ViewsSection
          visibility="personal"
          views={personal}
          otherSectionsHaveViews={team.length > 0}
          hasSiblingSection
          {...shared}
        />
      )}
      <ViewsSection
        visibility="team"
        views={team}
        otherSectionsHaveViews={hasPersonalSection && personal.length > 0}
        hasSiblingSection={hasPersonalSection}
        {...shared}
      />
    </div>
  )
}
